var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classText,staticStyle:{"font-size":"1.15rem"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }